import { ExperienceTemplateRenderer, TemplateComponentProps } from 'experience-template-renderer-react';
import * as React from 'react';

import { ErrorBoundary } from 'bernie-view';

import { ViewExtraLarge, Viewport } from '@shared-ui/viewport-context';

import { UitkLayoutFlexItem } from 'uitk-react-layout-flex';

export const SideRailRegion: React.FC<TemplateComponentProps> = ({ templateComponent }) => {
  const { children } = templateComponent;

  if (!children || children.length === 0) {
    return null;
  }

  return (
    <UitkLayoutFlexItem minWidth={160} maxWidth={160}>
      <div className="side-rail">
        <Viewport>
          <ViewExtraLarge>
            <ErrorBoundary label="hotel.masterPage.sideRail">
              {children && <ExperienceTemplateRenderer templateComponents={children} />}
            </ErrorBoundary>
          </ViewExtraLarge>
        </Viewport>
      </div>
    </UitkLayoutFlexItem>
  );
};
